import React, { PropTypes } from 'react';
import ReactDOMServer from 'react-dom/server';
import $ from 'jquery';

export const createModal = (title, content, promiseFunc, cb) => {
  // Creating dynamic modal
  const modal = ReactDOMServer.renderToStaticMarkup(
    <DynamicModal title={title} content={content} />
  );

  // Appending content to body
  $(document.body).append(modal);

  // Handling confirmation
  displayModal(promiseFunc, cb);
};

export function displayModal(promiseFunc, cb) {
  const $modal = $('#dynamic-action-modal');

  $modal
    .modal({
      onApprove: element => {
        $(element).addClass('loading');

        const promise = promiseFunc().then(
          res => {
            $(element).removeClass('loading');
            $modal.modal('hide');
          },
          err => {
            console.log('Error attempting to execute dynamic action', err);
            $(element).removeClass('loading');

            return Promise.reject(err);
          }
        );

        cb(promise);

        return false;
      },
    })
    .modal('show');
}

const DynamicModal = ({ title, content }) => (
  <div id="dynamic-action-modal" className="ui small modal">
    <div className="header">{title}</div>
    <div className="content">
      <p>{content}</p>
    </div>
    <div className="actions">
      <div className="ui red approve button">Confirmer</div>
      <div className="ui cancel button">Annuler</div>
    </div>
  </div>
);

DynamicModal.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/utils/dynamic-modal.js